export interface ShareTarget {
  key: "copy" | "whatsapp" | "x" | "linkedin";
  label: string;
  /** null means the client handles it locally (clipboard). */
  href: string | null;
}

export function shareMessage(input: {
  location: string;
  year: number;
  title: string;
  discovered: boolean;
}): string {
  if (input.discovered) {
    return `I did something no one had ever done in Amsterdam, ${input.year}: `
      + `"${input.title}". See what happened.`;
  }
  return `I travelled to Amsterdam in ${input.year}. See what happened.`;
}

export function buildShareTargets(input: { url: string; text: string }): ShareTarget[] {
  const url = encodeURIComponent(input.url);
  const text = encodeURIComponent(input.text);
  const both = encodeURIComponent(`${input.text} ${input.url}`);
  return [
    { key: "copy", label: "Copy link", href: null },
    { key: "whatsapp", label: "WhatsApp", href: `https://wa.me/?text=${both}` },
    { key: "x", label: "X", href: `https://twitter.com/intent/tweet?text=${text}&url=${url}` },
    { key: "linkedin", label: "LinkedIn", href: `https://www.linkedin.com/sharing/share-offsite/?url=${url}` },
  ];
}
